import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import logger from "../../../util/logger";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import cx from 'classnames';
import { extractElement, toUIProps } from "../../../util";
import { display, sizes, positions, colors, icons } from "../../../enums";
import { Dropdown as UIDropdown } from 'semantic-ui-react';
import { PrivateLabel } from "../label";
import Icon from "../icon";
import { mapHandlers, whitelistStyles } from "../hoc";
import { compose } from 'react-recompose';
import ErrorIcon from "../../abstractions/error-icon";
import evalPredicate from "../../../util/eval-predicate";
var UNSUPPORTED_PROPS = ['as', 'open', 'defaultValue', 'defaultSelectedLabel', 'defaultSearchQuery', 'name', 'trigger', //Add support when needed
'button', //Add support when needed or perhaps trigger is sufficient
'additionPosition', 'selectOnBlur', 'onBlur', 'closeOnBlur', 'closeOnChange', // 'onClick',
'onFocus', 'onMouseDown', 'onLabelClick', // add support when/if needed
'className', 'button', 'compact', 'fluid', 'floating', 'header', //Use more verbose form
'inline', 'labeled', //Use more verbose form
'linkItem', 'multiple', 'pointing', 'renderLabel', 'selectedLabel', 'selection', //Since we aren't using HTML forms for submission, couldn't think of valid use case
'simple', 'loading', 'error', 'disabled', 'scrolling' //I think we will want this, but might want to make dynamic by allowing the user to set max items or max height and applying scroll if overflow or something
];
var ADDED_PROPS = ['label', 'isFluid', 'isInline', 'allowMultiple', 'id', 'isLoading', 'hasError', 'hasErrorIcon', 'errorMessage', 'errorMessagePosition', 'isDisabled', 'isInverted', 'handleClear', // handler
'handleRemoveLabel', 'showClearIcon', 'allowAdditionsWhiteSpace', 'isUnderlined', 'onAddItemList'];
var MODIFIED_PROPS = ['options', 'style', 'searchQuery'];
var propMap = {
  isFluid: 'fluid',
  isInline: 'inline',
  allowMultiple: 'multiple',
  isLoading: 'loading',
  hasError: 'error',
  isDisabled: 'disabled',
  handleChange: 'onChange',
  handleSearchChange: 'onSearchChange',
  handleAddItem: 'onAddItem'
};
/**
 * WARNING: DO NOT USE
 *  - Use one of these abstractions instead.
 *   - <SingleSelect />
 *   - <MultiSelect />
 * TODO: This is a WIP. Only supporting current use cases.
 *   - Support for more verbose form
 *   - There are a lot of possible props that can be used. Add them as needed.
 *   - Some props HAVE to be used with others and CANNOT be used with others which is confusing. Create abstractions for these use cases.
 */

var Dropdown = createComponent({
  displayName: 'Dropdown',
  propTypes: {
    options: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    })).isRequired,
    // children TODO add in support for more verbose form
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))]),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    placeholder: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.element, //Icon only
    PropTypes.string, PropTypes.shape({
      content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
      position: PropTypes.oneOf(positions.LR)
    })]),
    isFluid: PropTypes.bool,
    isInline: PropTypes.bool,
    isLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    hasError: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    errorMessage: PropTypes.string,
    errorMessagePosition: PropTypes.oneOf(positions.ALL),
    isDisabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    allowAdditions: PropTypes.bool,
    //Requires options, search, selection
    allowAdditionsWhiteSpace: PropTypes.bool,
    onAddItem: PropTypes.func,
    onAddItemList: PropTypes.func,
    additionLabel: PropTypes.string,
    allowMultiple: PropTypes.bool,
    // True- Enable searching with the default search function string.contains
    // False- Disable searching
    // ()- Enable searching but use provided function
    search: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    noResultsMessage: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onSearchChange: PropTypes.func,
    showClearIcon: PropTypes.bool,
    defaultOpen: PropTypes.bool
  },
  defaultProps: {
    value: undefined,
    //null throws an error
    id: undefined,
    label: null,
    placeholder: 'Select an item...',
    icon: icons.DOWN,
    isFluid: true,
    isInline: false,
    isLoading: false,
    hasError: false,
    errorMessage: null,
    errorMessagePosition: positions.TOP_LEFT,
    isDisabled: false,
    allowAdditions: false,
    allowAdditionsWhiteSpace: false,
    onAddItem: null,
    onAddItemList: null,
    additionLabel: 'Add:',
    allowMultiple: false,
    search: false,
    onSearchChange: null,
    noResultsMessage: 'No results found.',
    showClearIcon: false,
    defaultOpen: false
  },
  state: {
    searchQuery: ''
  },
  handlers: {
    handleClear: function handleClear(p) {
      return function (e) {
        p.onChange(e, {
          id: p.id,
          value: p.allowMultiple ? [] : ''
        });
      };
    },
    handleChange: function handleChange(p) {
      return function (e, _ref) {
        var value = _ref.value;
        p.setSearchQuery('');
        p.onChange(e, {
          id: p.id,
          value: value
        });
      };
    },
    handleAddItem: function handleAddItem(p) {
      return function (e, _ref2) {
        var searchQuery = _ref2.searchQuery;
        if (p.onAddItem) p.onAddItem(e, {
          id: p.id,
          value: _trimInstanceProperty(searchQuery).call(searchQuery)
        }); //soon to be deprecated

        if (p.onAddItemList) {
          if (p.allowMultiple) {
            //calculate new potential additions
            var searchValues = p.allowAdditionsWhiteSpace ? [_trimInstanceProperty(searchQuery).call(searchQuery)] : _.uniq(_.words(_trimInstanceProperty(searchQuery).call(searchQuery), /[^, ]+/g));

            var _newAdditions = newAdditions(searchValues, p.options);

            var _values = _.union(p.value, searchValues);

            if (!_.isEmpty(_newAdditions)) p.onAddItemList(e, {
              id: p.id,
              value: _newAdditions
            }); //when we do an addition with data using the "Add:<input text>", we do not trigger the change action at all
            //this forces us to trigger the action on that specific addition
            //this will also make sure we are able to set the correct selected values via the onChange callback

            p.onChange(e, {
              id: p.id,
              value: _values
            });
          } else {
            //handle single select.
            var _newAdditions2 = newAdditions([_trimInstanceProperty(searchQuery).call(searchQuery)], p.options);

            if (!_.isEmpty(_newAdditions2)) p.onAddItemList(e, {
              id: p.id,
              value: _newAdditions2
            });
          }
        }

        p.setSearchQuery('');
      };
    },
    // for multi-select
    handleRemoveLabel: function handleRemoveLabel(p) {
      return function (e, labelProps) {
        var value = _.without(p.value, labelProps.value);

        p.onChange(e, {
          id: p.id,
          value: value
        });
      };
    },
    handleSearchChange: function handleSearchChange(p) {
      return function (e, _ref3) {
        var searchQuery = _ref3.searchQuery;
        // on search change if we are allowing additions and not allowing white space
        // we add the input value to the multiselect or singleselect options when a space is entered in the input
        var shouldAddSearchValue = p.allowAdditions && isLastCharSpace(searchQuery) && !p.allowAdditionsWhiteSpace;

        var trimmedSearchQuery = _trimInstanceProperty(searchQuery).call(searchQuery);

        if (!shouldAddSearchValue) {
          p.setSearchQuery(searchQuery);
        } else if (!p.allowMultiple && shouldAddSearchValue) {
          p.setSearchQuery('');
          p.onChange(e, {
            id: p.id,
            value: trimmedSearchQuery
          });
          !!p.onAddItem && p.onAddItem(e, {
            id: p.id,
            value: trimmedSearchQuery
          });

          var _newAdditions = newAdditions([trimmedSearchQuery], p.options);

          if (!_.isEmpty(_newAdditions)) {
            !!p.onAddItemList && p.onAddItemList(e, {
              id: p.id,
              value: _newAdditions
            });
          }
        } else if (shouldAddSearchValue) {
          var queryAddition = _.uniq(_.words(trimmedSearchQuery, /[^, ]+/g));

          var _value = _.union(p.value, queryAddition);

          !!p.onAddItem && p.onAddItem(e, {
            id: p.id,
            value: trimmedSearchQuery
          });

          if (!!p.onAddItemList) {
            var _newAdditions3 = newAdditions(queryAddition, p.options);

            if (!_.isEmpty(_newAdditions3)) {
              p.onAddItemList(e, {
                id: p.id,
                value: _newAdditions3
              });
            }
          }

          p.setSearchQuery('');
          p.onChange(e, {
            id: p.id,
            value: _value
          });
        }

        !!p.onSearchChange && p.onSearchChange(e, {
          id: p.id,
          value: searchQuery
        });
      };
    }
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(props) {
    /* TODO: if single-select, it would be nice (in the UI) to always have the currently
       selected option the first item in the list of options (top item of dropdown menu)
    */
    var UIProps = toUIProps({
      props: props,
      propMap: propMap,
      UNSUPPORTED_PROPS: UNSUPPORTED_PROPS,
      ADDED_PROPS: ADDED_PROPS,
      MODIFIED_PROPS: MODIFIED_PROPS
    });
    delete UIProps.fluid;
    delete UIProps.error;
    delete UIProps.setSearchQuery;
    UIProps.disabled = evalPredicate(props.isDisabled) || evalPredicate(props.isLoading);
    var icon = !evalPredicate(props.isLoading) ? extractElement(Icon, icons.DOWN, 'name') : undefined;
    UIProps.className = cx({
      inverted: props.isInverted,
      underlined: props.isUnderlined
    }); // Required by semantic-ui-react if options is defined

    UIProps.selection = true;
    UIProps.selectOnBlur = false;

    if (UIProps.multiple) {
      UIProps.renderLabel = function (label) {
        return /*#__PURE__*/React.createElement(PrivateLabel, {
          color: colors.SUPER,
          display: display.SOLID,
          isInverted: props.isInverted,
          isDisabled: UIProps.disabled,
          text: label.text,
          size: sizes.X2,
          value: label.value,
          onRemove: props.handleRemoveLabel
        });
      };
    }

    UIProps.icon = !!icon ? /*#__PURE__*/React.cloneElement(icon.element, {
      isDisabled: props.isDisabled
    }) : undefined;
    UIProps.options = _mapInstanceProperty(_).call(_, props.options, function (option, idx) {
      if (!!option.icon) {
        option.icon = extractElement(Icon, option.icon, 'name').element;
      }

      if (!option.key) return _Object$assign({}, option, {
        key: "" + option.value + idx
      });
      return option;
    });

    if (props.allowAdditions) {
      UIProps.search = true; //TODO Can/Should this be included as a PropType validation

      logger.warn('Dropdown: Missing PropType "onAddItemList" required when "allowAdditions = true"', !props.onAddItemList);
    }

    if (props.onAddItem) {
      logger.warn('The \'onAddItem\' function is now deprecated and will be removed soon. To ensure your code remains functional and up-to-date, please transition to using the \'onAddItemList\' function instead.');
    }

    if (UIProps.search) {
      UIProps.searchQuery = props.searchQuery;
    }

    logger.warn('Dropdown: propTypes "isDisabled" and "hasError" both set to true, this is invalid, please choose one or the other.', props.isDisabled && props.hasError);
    var wrapperClassNames = cx('ck dropdown', {
      error: evalPredicate(props.hasError) || !!props.errorMessage,
      disabled: UIProps.disabled,
      fluid: props.isFluid
    }); // disabled className needed on container for correct cursor styling

    return /*#__PURE__*/React.createElement("div", {
      className: wrapperClassNames,
      style: props.style
    }, props.label ? /*#__PURE__*/React.createElement(PrivateLabel, {
      text: props.label,
      isBasic: true,
      isDisabled: UIProps.disabled
    }) : null, /*#__PURE__*/React.createElement("div", {
      className: "error-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dropdown-positioner"
    }, props.showClearIcon && (!_.isEmpty(props.value) || _.isNumber(props.value)) ? /*#__PURE__*/React.createElement(Icon, {
      name: icons.CANCEL,
      size: sizes.X5,
      onClick: props.handleClear,
      isDisabled: UIProps.disabled
    }) : null, /*#__PURE__*/React.createElement(UIDropdown, UIProps)), /*#__PURE__*/React.createElement(ErrorIcon, {
      errorMessagePosition: props.errorMessagePosition,
      errorMessage: props.errorMessage
    })));
  }
});

function isLastCharSpace(value) {
  return value.charAt(value.length - 1) === ' ';
}
/**
 * Compare the UNIQUE additions that the user tries to add VS our existing option list from the drop down and figure out which of the additions are actually new and which are duplicated, already part of the option list from the dropdown.
 * @param {array} queryAddition - an array of unique strings that the user has input
 * @param {array} options - an array of unique values (not necessarily strings) that we already have in our options list
 * @returns {array} an array of unique values that the user CAN add as part of queryAddition that are not part of our original option list
 */


function newAdditions(queryAddition, options) {
  //fetch all the values of the options we already in the list
  // p.options as an array generally has the shape of:
  // { text: //.. , value: //... }
  // where the [text] is presented as a visual dropdown input and
  // [value] is the value marked behind the scenes
  // we NEED only the [value] to compare against queryAddition to ensure uniqueness of option entries
  var optionValues = options ? _mapInstanceProperty(_).call(_, options, 'value') : [];
  return _.difference(queryAddition, optionValues);
}

export default compose(mapHandlers({
  change: [],
  addItem: [],
  addItemList: [],
  searchChange: []
}), whitelistStyles())(Dropdown);
//# sourceMappingURL=dropdown.js.map